import axios from 'axios';
import { Capacitor } from '@capacitor/core';
import { PAYMENT_FEATURES } from '../../config/featureFlags';
import { GooglePlayBillingProvider, GOOGLE_PLAY_MONTHLY_PRODUCT_ID } from './providers/googlePlayBillingProvider';
import { PROVIDERS } from './paymentProviders';

class PaymentService {
  constructor() {
    this.providers = {
      [PROVIDERS.GOOGLE_PLAY]: new GooglePlayBillingProvider(),
    };
  }

  getPreferredProvider() {
    if (Capacitor.getPlatform() === 'android' && PAYMENT_FEATURES.ENABLE_GOOGLE_PLAY_BILLING) {
      return PROVIDERS.GOOGLE_PLAY;
    }
    return PROVIDERS.GOOGLE_PLAY;
  }

  async startPremiumCheckout() {
    const provider = this.getPreferredProvider();
    const purchaseResult = await this.providers[provider].startSubscription(GOOGLE_PLAY_MONTHLY_PRODUCT_ID);
    if (!purchaseResult.success || !purchaseResult.purchase) return purchaseResult;

    const verifyRes = await axios.post('/subscription/google-play/verify', {
      purchase_token: purchaseResult.purchase.purchaseToken,
      product_id: purchaseResult.purchase.productId,
      order_id: purchaseResult.purchase.orderId,
      status: purchaseResult.purchase.status || 'ACTIVE',
    });
    return { success: true, message: verifyRes.data?.message || 'Abonnement active via Google Play.' };
  }

  async restorePurchases() {
    const purchaseResult = await this.providers[PROVIDERS.GOOGLE_PLAY].restorePurchases();
    if (!purchaseResult.success) return purchaseResult;

    for (const purchase of purchaseResult.purchases || []) {
      await axios.post('/subscription/google-play/verify', {
        purchase_token: purchase.purchaseToken,
        product_id: purchase.productId,
        order_id: purchase.orderId,
        status: purchase.status || 'ACTIVE',
      });
    }

    return {
      success: true,
      message: (purchaseResult.purchases || []).length > 0
        ? 'Achats restaures avec succes.'
        : 'Aucun abonnement a restaurer.',
    };
  }
}

export const paymentService = new PaymentService();
